// Справочники окна «Общие сведения»: часовые пояса и подсказки под формой. Сами настройки — на сервере (/api/settings).

import { t } from "@/lib/i18n";

export const timeZones = [
  { id: "Europe/Rome", label: t("(GMT+01:00) Европа/Рим") },
  { id: "Europe/Moscow", label: t("(GMT+03:00) Европа/Москва") },
  { id: "Europe/London", label: t("(GMT+00:00) Европа/Лондон") },
  { id: "Europe/Berlin", label: t("(GMT+01:00) Европа/Берлин") },
  { id: "Asia/Almaty", label: t("(GMT+05:00) Азия/Алматы") },
  { id: "Asia/Dubai", label: t("(GMT+04:00) Азия/Дубай") },
  { id: "Asia/Tokyo", label: t("(GMT+09:00) Азия/Токио") },
  { id: "America/New_York", label: t("(GMT−05:00) Америка/Нью-Йорк") },
  { id: "UTC", label: "(GMT+00:00) UTC" },
];

// подсказки под формой
export const generalHints = [
  {
    icon: "ri-price-tag-3-line",
    title: t("Название в письмах"),
    text: t("Название рабочего пространства видно в уведомлениях, дайджесте и в письмах клиентам."),
  },
  {
    icon: "ri-lock-2-line",
    title: t("Тайм-аут безопасности"),
    text: t("Если сотрудник неактивен дольше тайм-аута, он выходит из системы и входит через Google заново."),
  },
  {
    icon: "ri-mail-send-line",
    title: t("Дайджест по понедельникам"),
    text: t("Раз в неделю приходит сводка по диалогам и жизненному циклу — только выбранным получателям."),
  },
];